import { PhnxButton } from '@/components/01-atoms/Button/Button'
import { PhnxImageHolder } from '@/components/01-atoms/ImageHolder/ImageHolder'
import { PhnxCard } from '@/components/02-molecules/Card/Card'

import styles from './Featuredarticles.module.css'

export type FeaturedarticlesProps = {
  featured: any
  items: any[]
}

export const PhnxFeaturedarticles: React.FC<FeaturedarticlesProps> = ({ featured, items }) => {
  return (
    <div className={`${styles.featuredarticles} container`}>
      {featured && featured.link && (
        <div className={styles.featured}>
          <PhnxCard
            title={featured.title}
            variant="senary"
            layout="vertical"
            alignment="default"
            style="float"
            subtitle={
              <div>
                <div className="date">{featured.date}</div>
                <div className="timetoread">{featured.timeToRead}</div>
              </div>
            }
            button={
              <PhnxButton
                type="link"
                href={featured.link}
                variant="primary"
                label="Read Story"
                size="small"
              />
            }
            asset={
              <PhnxImageHolder
                images={[
                  {
                    src: featured?.image?.src,
                    alt: featured?.image?.alt,
                    focus: featured?.image?.focus,
                  },
                ]}
              />
            }
            link={featured.link}
            tags={featured.tags ? featured.tags : []}
          />
        </div>
      )}
      {items && items.length > 0 && (
        <div className={styles.subcard}>
          {items &&
            items.map((item, index) => (
              <PhnxCard
                key={index}
                title={item.title}
                variant="quinary"
                layout="horizontal"
                alignment="default"
                style="float"
                subtitle={
                  <div>
                    <div className="date">{item.date}</div>
                    <div className="timetoread">{item.timeToRead}</div>
                  </div>
                }
                button={
                  <PhnxButton
                    type="link"
                    href={item.link}
                    variant="quinary"
                    label="Read Story"
                    size="small"
                  />
                }
                asset={
                  <PhnxImageHolder
                    images={[
                      {
                        src: item?.image?.src,
                        alt: item?.image?.alt,
                        focus: item?.image?.focus,
                      },
                    ]}
                  />
                }
                link={item.link}
                tags={item.tags}
              />
            ))}
        </div>
      )}
    </div>
  )
}
